<template>
    <v-container>
        <v-card class="mb-12" style="padding: 1rem">
            <v-card-title>Generar obras</v-card-title>
            <template v-for="(linea_group, index) in this.lineas">
                <v-card
                    style="
                        margin: 2rem;

                        padding: 1rem;
                    "
                >
                    <v-row>
                        <v-col cols="12">
                            <h3>Obra {{ index + 1 }}</h3>
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-switch
                                v-model="linea_group.taller"
                                label="Taller"
                            ></v-switch>
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-switch
                                v-model="linea_group.lacado"
                                label="Lacado"
                            ></v-switch>
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-switch
                                v-model="linea_group.elevacion"
                                label="Elevación"
                            ></v-switch>
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-switch
                                v-model="linea_group.instalacion_electrica"
                                label="Instalación eléctrica"
                            ></v-switch>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="4">
                            <date-select
                                label="Fecha de planificación"
                                v-model="linea_group.fecha_planificacion"
                            ></date-select>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6">
                            <h4>Productos</h4>
                        </v-col>
                        <v-col
                            cols="6"
                            style="display: flex; justify-content: end"
                        >
                            <v-btn
                                v-if="desagrupando != index"
                                color="red"
                                class="white--text"
                                @click="desagrupando = index"
                                >Desagrupar</v-btn
                            >
                            <v-btn
                                v-else
                                color="red"
                                class="white--text"
                                @click="desagrupando = null"
                                >Cancelar</v-btn
                            >
                            <v-btn
                                v-if="agrupando != index"
                                color="success"
                                @click="agrupando = index"
                                >Agrupar</v-btn
                            >
                            <v-btn
                                v-else
                                color="red"
                                class="white--text"
                                @click="agrupando = null"
                                >Cancelar</v-btn
                            >
                        </v-col>
                        <template
                            v-for="(
                                linea, index_producto
                            ) in linea_group.productos"
                        >
                            <v-col cols="12" md="3">
                                <template v-if="linea.producto">
                                    {{ linea.producto.denominacion }}
                                </template>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-textarea
                                    label="Descripción"
                                    v-model="linea.descripcion"
                                >
                                </v-textarea>
                            </v-col>
                            <v-col cols="12" md="2">
                                <v-btn
                                    v-if="
                                        desagrupando == index &&
                                        desagrupando != null
                                    "
                                    color="red"
                                    class="white--text"
                                    @click="Desagrupar(index, index_producto)"
                                    >Desagrupar</v-btn
                                >
                                <v-btn
                                    v-if="
                                        agrupando != index && agrupando != null
                                    "
                                    color="success"
                                    @click="
                                        lineas[agrupando].productos.push(linea);
                                        agrupando = null;
                                        linea_group.productos.splice(
                                            index_producto,
                                            1
                                        );
                                        if (linea_group.productos.length == 0)
                                            lineas.splice(index, 1);
                                    "
                                    >Agrupar</v-btn
                                >

                                <!--Boton de eliminar, se uso para un caso especifico, mantener comentado por si es necesario volver a usar-->
                                <!-- <v-btn @click="Eliminar(index, index_producto)"
                                    >Eliminar</v-btn
                                > -->
                            </v-col>
                        </template>
                    </v-row>
                </v-card>
            </template>
        </v-card>

        <v-btn
            color="primary"
            @click="
                e1 = 3;
                generateValidacion($route.query.id);
            "
        >
            Continuar
        </v-btn>

        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                    >¿Está seguro de aceptar?</v-card-title
                >
                <v-card-text style="text-align: center">
                    <h2>
                        Al pulsar aceptar, estará de acuerdo con la viabilidad
                        del presupuesto
                    </h2>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        color="red"
                        @click="dialog = false"
                        class="white--text"
                        >Cancelar</v-btn
                    >

                    <v-btn
                        color="success"
                        @click="
                            dialog = false;
                            e1 = 2;
                            ValidatePresupuesto();
                        "
                        >Aceptar</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import ShowPresupuesto from "./componentes_stepper/ShowPresupuesto.vue";
import PedidoEditor from "./componentes_stepper/PedidoEditor.vue";
export default {
    components: { ShowPresupuesto, PedidoEditor },
    data() {
        return {
            pedidos: [],
            dialog: false,
            e1: 2,
            agrupando: null,
            desagrupando: null,
            presupuesto: {},
            lineas: [],
        };
    },
    created() {
        if (this.$route.query.id != null) {
            //this.GenerateOrdenLocal(this.$route.query.id);
            this.getPresupuesto(this.$route.query.id);
        }
    },
    watch: {
        pedidos(val) {
            console.log(val);
        },
        e1: function (val) {
            if (val == 2) {
                this.GenerateOrdenLocal(this.$route.query.id);
            } else if (val == 3) {
            }
        },
    },
    methods: {
        generatePedidos() {
            axios
                .post(`api/save-pedidos-proveedor`, {
                    pedidos: this.pedidos,
                })
                .then(
                    (res) => {
                        //this.presupuesto.pedidos = res.data;
                    },
                    (res) => {}
                );
        },
        generateValidacion(id) {
            axios
                .post(`api/generate-orden`, {
                    ordenes: this.lineas,
                    id_presupuesto: id,
                })
                .then(
                    (res) => {
                        this.presupuesto.ordenes = res.data;
                        this.$router.push("lista-ordenes");
                    },
                    (res) => {}
                );
        },
        ValidatePresupuesto(id) {
            axios.get(`/validate-presupuesto/${id}`).then((res) => {
                this.presupuesto.lineas = res.data;
                this.GenerateOrdenLocal();
            });
        },
        Desagrupar(index, index_producto) {
            const element = this.lineas[index].productos[index_producto];
            this.lineas.push({
                id_presupuesto: this.$route.query.id,
                hora: "",
                observaciones: "",
                descripcion_linea: "",
                id_tipo: 1,
                id_estado: 1,
                taller: 0,
                lacado: 0,
                elevacion: 0,
                instalacion_electrica: 0,
                id_producto: element.id_producto,
                productos: [element],
            });
            this.lineas[index].productos.splice(index_producto, 1);
            if (this.lineas[index].productos.length == 0)
                this.lineas.splice(index, 1);
        },
        getPresupuesto(id) {
            axios.get(`api/getpresupuesto/${id}`).then(
                (res) => {
                    this.presupuesto = res.data;

                    this.GenerateOrdenLocal();
                },
                (res) => {}
            );
        },
        GenerateOrdenLocal(id) {
            const lineas = this.presupuesto.lineas;
            if (this.presupuesto.ordenes.length > 0) {
                this.lineas = this.presupuesto.ordenes;
                return;
            }

            const base_imponible = lineas.reduce((acc, element) => {
                return acc + parseFloat(element.total);
            }, 0);

            this.lineas = [];
            let total_ordenes = 0;
            const subtotal = parseFloat(this.presupuesto.total) / 1.21;
            lineas.forEach((element) => {
                let linea = null;
                linea = this.lineas.find((lin) => {
                    return lin.id_producto == element.id_producto;
                });

                let dcto = 0;
                if (this.presupuesto.id_tipo_dcto == 0) {
                    // descuento porcentual
                    dcto =
                        (parseFloat(element.total) *
                            parseFloat(this.presupuesto.dcto)) /
                        100;
                } else {
                    // descuento total en euros
                    const porcentaje =
                        (parseFloat(this.presupuesto.dcto) * 100) /
                        base_imponible;
                    dcto = (parseFloat(element.total) * porcentaje) / 100;
                }

                const precio = parseFloat(element.total) - dcto;
                total_ordenes += parseFloat(precio.toFixed(2));

                const producto = {
                    id_elemento: element.id, // Es el id de presupuesto_linea
                    id_producto: element.id_producto,
                    producto: element,
                    descripcion: element.descripcion,
                    precio: precio.toFixed(2),
                };

                if (linea != null) {
                    linea.productos.push(producto);
                } else {
                    //console.log(element);
                    this.lineas.push({
                        id_presupuesto: id,
                        hora: "",
                        observaciones: "",
                        descripcion_linea: "",
                        id_tipo: 5,
                        id_estado: 1,
                        taller: 0,
                        lacado: 0,
                        fecha_planificacion: null,
                        elevacion: (this.presupuesto?.mudanza ?? 0) > 0 ? 1 : 0,
                        instalacion_electrica: element.electrica,
                        id_producto: element.id_producto,
                        productos: [producto],
                    });
                }
            });

            // Ajuste para corregir la diferencia por redondeos
            const diferencia = total_ordenes - subtotal;
            if (Math.abs(diferencia) > 0) {
                // Ajustar la primera línea para corregir la diferencia
                const primerProducto = this.lineas[0].productos[0];
                primerProducto.precio -= diferencia.toFixed(2); // Corregir precio en la primera línea
            }

            console.log("lineas", this.lineas);
        },
        // Funcion auxiliar para eliminar una linea de la lista de lineas (se uso para un caso especifico, mantener comentado por si es necesario volver a usar)
        Eliminar(index, index_producto) {
            console.log("lineas antes:", this.lineas);

            this.lineas[index].productos.splice(index_producto, 1);
            if (this.lineas[index].productos.length == 0)
                this.lineas.splice(index, 1);

            console.log("lineas despues:", this.lineas);
        },
    },
};
</script>
